// App.js
import { BrowserRouter as Router } from "react-router-dom";
import AppContent from "./AppContent";

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <AppContent />
    </Router>
  );
}

export default App;
